class TableOfContents extends HTMLElement {
    constructor() {
        super();
  
        this.articleH2Elements = document.querySelectorAll(".Article__Content h2");
        this.articleH2Elements.length && this.init();
        
        this.toggleTableButton = this.querySelector("#table-of-contents-toggle");
        this.tableItems = this.querySelectorAll(".table-contents-li a");

        this.toggleTableButton.addEventListener("click", this.toggleTable.bind(this));
        this.tableItems.forEach((item) => {
            item.addEventListener("click", this.scrollToItem.bind(this));
        });
    }

    init() {
        let table_list = "";
        table_list += "<div><div class='table-heading'>Table Of Contents</div><div id='table-of-contents-toggle'>Hide</div></div>";
        table_list += '<ol class="active">';
  
        for(let i = 0; i < this.articleH2Elements.length; i++){
            if(!this.articleH2Elements[i].classList.contains("ProductItem__Title")){
                this.articleH2Elements[i].id = `table_of_contents_${i + 1}`;
                table_list += `<li class="table-contents-li"><a class='table_of_contents_link' href='#table_of_contents_${i + 1}'>` + this.articleH2Elements[i].innerText + '</a></li>'; 
            }
        }
  
        table_list += '</ol>';
        this.innerHTML = table_list;
    }

    toggleTable(event) {
        this.tableContent = this.querySelector("ol");
        this.toggleButtonText = event.target.innerText.toLowerCase();
        
        this.toggleButtonText === "show" ? event.target.innerText = "Hide" : event.target.innerText = "Show";
        this.tableContent.classList.contains("active") ? this.tableContent.classList.remove("active") : this.tableContent.classList.add("active");
    }

    scrollToItem(event) {
        event.preventDefault();

        const href = event.target.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;
  
        window.scroll({
            top: offsetTop + 200,
            behavior: "smooth"
        });
    }
}

customElements.define('table-of-contents', TableOfContents);